import { axios, fileAxios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesPsicologicas: [],
    evaluacionesPsicologicasExpediente: [],
  },

  getters: {
    getEvaluacionesPsicologicas: (state) => state.evaluacionesPsicologicasExpediente,
  },

  mutations: {
    SET_EVALUACIONES_PSICOLOGICAS(state, evaluacionesPsicologicas) {
      state.evaluacionesPsicologicas = evaluacionesPsicologicas;
    },

    SET_EVALUACIONES_PSICOLOGICAS_EXPEDIENTE(state, evaluacionesPsicologicasExpediente) {
      state.evaluacionesPsicologicasExpediente = evaluacionesPsicologicasExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesPsicologicas({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/evaluacionespsicologicas')
        .then((response) => {
          commit('SET_EVALUACIONES_PSICOLOGICAS', response.data.data);
        });
    },

    async fetchEvaluacionesPsicologicasByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionespsicologicas`)
        .then((response) => {
          commit('SET_EVALUACIONES_PSICOLOGICAS_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionPsicologica(context, evaluacionPsicologica) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionPsicologica.fk_idExpediente}/evaluacionespsicologicas`, evaluacionPsicologica)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', evaluacionPsicologica.file);
          formData.append('File_FuncionesDesempenia', evaluacionPsicologica.fileFuncionesDesempeña);
          formData.append('File_DatosGenerales', evaluacionPsicologica.fileDatosGenerales);
          formData.append('File_DatosFamiliares', evaluacionPsicologica.fileDatosFamiliares);
          formData.append('idPsicologico', response.data.data[0].ID);
          context.dispatch('uploadEvaluacionPsicologica', formData);
        });
    },

    async updateEvaluacionPsicologica(_, evaluacionPsicologica) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${evaluacionPsicologica.fk_idExpediente}/evaluacionespsicologicas`, evaluacionPsicologica);
    },

    async uploadEvaluacionPsicologica(context, formData) {
      await fileAxios
        .post('/C3/SetAdjuntosEvaluacionesPsicologicas/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación psicológica guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
